import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import { PiUser } from "react-icons/pi";
import { Link } from "react-router-dom";
import logo from '../assets/logo1.png';
import '../css/Navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className="navbar">
      <div className="navbar-links">
        <div className="navbar-links_logo">
          <Link to="/">
            <img src={logo} alt="logo" />
            
          </Link>
        </div>
      </div>
      <div className="navbar-sign">
        <Link to="/login">
          <button className="sign-in-button">
            <PiUser className="user-icon" /> Sign In
          </button>
        </Link>
      </div>
      <div className="navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#FDDA24" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#FDDA24" size={27} onClick={() => setToggleMenu(true)} />}
        {/* {toggleMenu && (
          <div className="navbar-menu_container scale-up-center">
            <div className="navbar-menu_container-links">
              <Link to="/" onClick={() => setToggleMenu(false)}><p>Home</p></Link>
              <div className="navbar-menu_container-links-sign">
                <Link to="/login" onClick={() => setToggleMenu(false)}><p>Sign in</p></Link>
                <Link to="/signup" onClick={() => setToggleMenu(false)}><button type="button">Sign up</button></Link>
              </div>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default Navbar;
